module.exports = __webpack_public_path__ + "static/P4-7826b60664fbfbb76bb8360fac4a3045.webp";